var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFetImg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 88,
    viewBox: "0 0 132 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    width: 130.583,
    height: 87.9271,
    rx: 11.5157,
    fill: "#FFEDD1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4707 43.5C66.4707 38.8056 70.2763 35 74.9707 35C79.6651 35 83.4706 38.8057 83.4706 43.5C83.4706 48.1945 79.665 51.9999 74.9707 51.9999C70.2762 51.9999 66.4707 48.1944 66.4707 43.5Z",
    fill: "#00BCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4707 60.4999C49.4707 55.8055 53.2763 51.9999 57.9707 51.9999L62.5004 49.6084L66.4706 51.9999V60.4999C66.4706 65.1944 62.6651 68.9999 57.9707 68.9999C53.2763 68.9999 49.4707 65.1943 49.4707 60.4999Z",
    fill: "#00CF7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 18L61.8447 26.0355L66.47 34.9999H74.8507C79.5452 34.9999 83.3507 31.1944 83.3507 26.5C83.3507 21.8056 79.5451 18 74.8507 18H66.47Z",
    fill: "#FF7361"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3506 26.5C49.3506 31.1944 53.1562 34.9999 57.8506 34.9999L62.3596 36.7415L66.4697 34.9999V18H57.8505C53.1562 18 49.3506 21.8056 49.3506 26.5Z",
    fill: "#FF4D12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4707 43.5001C49.4707 48.1946 53.2763 52 57.9707 52H66.4706V35H57.9707C53.2763 35 49.4707 38.8057 49.4707 43.5001Z",
    fill: "#B659FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetImg7);
export default __webpack_public_path__ + "static/media/fet-img (7).fbf2ad161621146ee2f63929a8c004ea.svg";
export { ForwardRef as ReactComponent };